import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { Entry } from 'contentful';
import { TitleseoService } from './hiddenWhitepaperSeo.service';

@Injectable({
  providedIn: 'root',
})
export class HiddenWhitepaperArticleResolver implements Resolve<Entry<any>[]> {
  constructor(private titleSeoService: TitleseoService) {}
  resolve(route: ActivatedRouteSnapshot): Promise<Entry<any>[]> {
    return this.titleSeoService.getSeoData(
      route.data?.['param']?.contentType,
      route.paramMap.get('whitepaperid')
    );
  }
}
